import { useState } from 'react';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import { useAdmin } from '../../../context/AdminContextProvider';
import GenericButton from '../../../components/buttons/GenericButton';
import { useGetTeacherName, useDeactivateTeachers } from './TeacherActionHooks';
import CustomDialog from '../../../../../components/dialog/CustomDialog';
import { filterUndefined } from '../../../../../utils/FilterUndefinedObject';

const defaultProps = {
  onTeacherDeactivateSuccess: () => null,
};

const DeactivateTeacherAction = (p) => {
  const {
    onTeacherDeactivateSuccess,
  } = { ...defaultProps, ...filterUndefined(p) };

  const [open, setOpen] = useState(false);
  const { adminTeachersDomain } = useAdmin();
  const { selectedTeacherIds } = adminTeachersDomain.domainData;
  const handleOnCancel = () => {
    setOpen(false);
  };

  const {
    getTeacherName,
  } = useGetTeacherName();

  const {
    deactivateTeachers,
    loading,
  } = useDeactivateTeachers({
    setOpen,
    onTeacherDeactivateSuccess,
  });

  const confirmActions = [{
    onClick: handleOnCancel,
    className: 'btn-danger margin-right',
    title: 'No',
    loading,
  }, {
    onClick: () => {
      deactivateTeachers();
    },
    className: 'btn-primary action-button',
    title: 'Yes',
    loading,
  },
  ];

  return (
    <>
      <GenericButton
        ariaLabel={`Deactivate Teacher${selectedTeacherIds.length > 1 ? 's' : ''}`}
        onClick={() => {
          setOpen(true);
        }}
        disabled={!selectedTeacherIds || selectedTeacherIds.length === 0}
        icon={RemoveCircleIcon}
      />
      {open && (
        <CustomDialog
          openDialog={open}
          onClose={handleOnCancel}
          title={`Deactivate Teacher${selectedTeacherIds.length > 1 ? 's' : ''}`}
          content={(
            <div data-dd-privacy='mask'>
              Are you sure you want to deactivate {selectedTeacherIds.length === 1 ? getTeacherName(selectedTeacherIds[0]) : 'the selected teachers'}?
            </div>
          )}
          displayCloseIcon
          actions={confirmActions}
        />
      )}
    </>
  );
};

export default DeactivateTeacherAction;
